import { InputCurrency } from "components/shared/input-currency";
import React from "react";
import { useTenantSettings } from "store/selectors/settings";

interface ClientDefaultFinanceQuestionsProps {
    budgetMonthly: string;
    budgetTotal: string;
    onFieldChange: (fieldName: string, newValue: string) => void;
}

export const ClientDefaultFinanceQuestions: React.FC<
    ClientDefaultFinanceQuestionsProps
> = props => {
    const { budgetMonthly, budgetTotal, onFieldChange } = props;
    const { settings } = useTenantSettings();

    return (
        <div className="flex space-x-4">
            {settings.showClientMonthlyBudget || budgetMonthly ? (
                <div className="flex-1">
                    <InputCurrency
                        label="Monthly Budget"
                        initial={budgetMonthly}
                        onCommit={newVal => onFieldChange("budgetMonthly", newVal)}
                    />
                </div>
            ) : null}
            {settings.showClientTotalFinances || budgetTotal ? (
                <div className="flex-1">
                    <InputCurrency
                        label="Total Finances"
                        initial={budgetTotal}
                        onCommit={newVal => onFieldChange("budgetTotal", newVal)}
                    />
                </div>
            ) : null}
        </div>
    );
};
